import { OnSalePeriod } from "./onsaleperiod";

export class ProductsOnSale {
    productId?:number;
    onSalePeriod?:OnSalePeriod;
}
